const MAP = {
  present: ["On Time", "bg-emerald-100 text-emerald-800 border-emerald-300/60"],
  late: ["Late", "bg-amber-100 text-amber-800 border-amber-300/60"],
  absent: ["Absent", "bg-rose-100 text-rose-800 border-rose-300/60"],
  weekly_off: ["Weekly Off", "bg-indigo-100 text-indigo-800 border-indigo-300/60"],
  holiday: ["Holiday", "bg-sky-100 text-sky-800 border-sky-300/60"],
  sick_leave: ["Sick Leave", "bg-fuchsia-100 text-fuchsia-800 border-fuchsia-300/60"],
  active: ["Active", "bg-emerald-100 text-emerald-800 border-emerald-300/60"],
  escaped: ["Escaped", "bg-orange-100 text-orange-800 border-orange-300/60"],
  terminated: ["Terminated", "bg-slate-200 text-slate-700 border-slate-400/60"],
  inactive: ["Inactive", "bg-slate-100 text-slate-500 border-slate-300"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = MAP[status] || [status, "bg-slate-100 text-slate-700 border-slate-300"];
  return (
    <span data-testid={testId} className={`inline-flex items-center px-2.5 py-0.5 rounded-full border font-mono text-[11px] font-bold uppercase tracking-wider ${cls}`}>
      {label}
    </span>
  );
};
